module.exports = __webpack_public_path__ + "img/502.c1cff59f.png";